import React, {useState, useEffect} from 'react';
import DangerButton from './DangerButton';
import DialogModal from './DialogModal';
import SecondaryButton from './SecondaryButton';
import request from '../utils/request';
import SelectDropdown from './SelectDropdown';
// import {useNavigate} from 'react-router-dom';

export default function ChangeDeliveryFee({entry, setMessage, driverData = null, onSuccess}) {
    const [open, setOpen] = useState(false);
    const [fee, setFee] = useState(entry.driverPay ?? entry.tip + entry.driverFee);
    const [feeInput, setFeeInput] = useState((entry.driverPay ?? entry.tip + entry.driverFee).toFixed(2));
    const [loading, setLoading] = useState(false);
    const [predictedPay, setPredictedPay] = useState(null);
    const [payError, setPayError] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);

    const handleSubmit = async () => {
        if (!fee && fee !== 0) {
            return;
        }

        setLoading(true);

        try {
            const payload = {
                oid: entry._id,
                driverPay: fee
            };

            // If driver is selected, include driverID to assign driver and prevent release to requests
            if (selectedDriver?.value) {
                payload.driverID = selectedDriver.value;
            }

            await request.post('admin/driver-fee', payload);

            setLoading(false);
            setOpen(false);
            
            if (selectedDriver?.value) {
                setMessage(`Driver pay set and driver assigned. Order will not be released to requests.`);
            } else {
                setMessage('Delivery charges have been updated. Order released to drivers.');
            }
            onSuccess?.();
        } catch (error) {
            setLoading(false);
            console.error('Error updating driver fee:', error);
            setMessage(error.response?.data?.message || 'Failed to update driver fee.');
        }
    }
    // const navigate = useNavigate();

    // const getCleaningStatus = async () => {
    //     await request.get(`orders/get-streamline-reservation/${entry._id}`);
    //     navigate('/orderList');
    // };

    useEffect(() => {

        setPredictedPay(null)
        setPayError(null)

        request
            .get(`/orders/predict/${entry._id}`)
            .then(res => {
                setPredictedPay(res.data.predictedPay)
            })
            .catch(err => {
                console.warn("Predictor error:", err)
                setPayError("Could not load prediction")
            })
    }, [entry.uniqueId, entry._id])

    // Reset selected driver when modal opens
    useEffect(() => {
        if (open) {
            setSelectedDriver(null);
        }
    }, [open]);

    const isPlaced = entry.storeSpend && !isNaN(parseFloat(entry.storeSpend)) && parseFloat(entry.storeSpend) > 0 &&
                     entry.storeOrderId && entry.storeOrderId.trim() !== '';

    return (
        <div>
            <button
                className={`px-2 py-1 text-xs font-medium rounded-lg border transition-colors whitespace-nowrap ${
                    isPlaced
                        ? 'bg-emerald-500 hover:bg-emerald-600 text-white border-emerald-400'
                        : 'bg-sky-500 hover:bg-sky-600 text-white border-sky-400'
                }`}
                onClick={() => setOpen(true)}
            >
                Edit
            </button>

            {/* {(entry.property?.propertySource === 'streamline' || entry.property?.propertySource === 'guesty') && (
                <div
                    className={`m-2 px-2 md:px-4 h-[30px] flex items-center cursor-pointer justify-center border rounded-md whitespace-nowrap overflow-hidden text-ellipsis `}
                    onClick={() => getCleaningStatus()}
                >
                    Refresh Property Status
                </div>
            )} */}

            <DialogModal openModal={open} setOpenModal={setOpen}>
                <DialogModal.Content title={'Edit Delivery Charges'}>
                    <form className="flex justify-between rounded">
                        <div className='w-full'>
                            <div className="mb-4 ml-2">
                                <label className="block text-gray-700 text-sm font-bold mb-2"
                                       htmlFor="total_delivery_charges">
                                    Total Delivery Charges
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="total_delivery_charges"
                                    type="number"
                                    placeholder="Enter Delivery Charges"
                                    name="total_delivery_charges"
                                    disabled
                                    value={(entry.tip + entry.driverFee).toFixed(2)}
                                />
                            </div>
                            <div className="mb-4 ml-2">
                                <label className="block text-gray-700 text-sm font-bold mb-2"
                                       htmlFor="new_delivery_charges">
                                    New Delivery Charges
                                </label>
     <input
  type="text"
  inputMode="decimal"
  placeholder="Enter Delivery Charges"
  className="shadow border rounded w-full py-2 px-3 text-gray-700
             focus:outline-none focus:shadow-outline"
  value={feeInput}
  onChange={e => {
    const v = e.target.value;
    /* allow only digits and a single optional dot while typing */
    if (/^\d*\.?\d*$/.test(v)) {
      setFeeInput(v);
    }
  }}
  onBlur={() => {
    /* coerce to a number with exactly 2 decimals */
    const n = parseFloat(feeInput) || 0;
    setFeeInput(n.toFixed(2));
    setFee(n);
  }}
/>


                            </div>
                            <div className="mb-4 ml-2">
                                <div className="text-gray-700 font-bold mb-2">Suggested Driver Pay</div>
                                <div className="font-mono text-green font-bold">
                                    {predictedPay != null
                                        ? `$${predictedPay.toFixed(2)}`
                                        : payError
                                            ? <span className="text-red-600">{payError}</span>
                                            : "…"}
                                </div>
                            </div>
                            {driverData && driverData.length > 0 && (
                                <div className="mb-4 ml-2">
                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="assign_driver">
                                        Assign Driver (Optional)
                                    </label>
                                    <p className="text-xs text-gray-500 mb-2">
                                        If assigned, order will be set to pending and won't be released to other drivers
                                    </p>
                                    <SelectDropdown
                                        value={selectedDriver}
                                        options={driverData.map((driver) => ({
                                            label: driver.name,
                                            value: driver.id
                                        }))}
                                        isMulti={false}
                                        onChange={(option) => setSelectedDriver(option)}
                                        placeholder="Select driver (optional)"
                                    />
                                </div>
                            )}
                        </div>
                    </form>
                </DialogModal.Content>
                <DialogModal.Footer>
                    <SecondaryButton className='p-2 border-blue text-blue'
                                     onClick={handleSubmit}>{loading ? 'Saving...' : 'Save'}</SecondaryButton>
                    <DangerButton className='p-2 border-red text-red'
                                  onClick={() => setOpen(false)}>Cancel</DangerButton>
                </DialogModal.Footer>
            </DialogModal>
        </div>
    );
}
